/**
 * Extension list for robot descriptions that can be ingested as a 3D asset.
 *
 * `.xacro` is deliberately absent. It is a macro language *over* URDF, and the
 * converter does no macro expansion — offering to ingest one would produce a
 * failure the user cannot act on.
 */
export const urdfFileTypes = ["urdf"];

/** Files that can be converted into a viewable, articulated 3D asset. */
export const isUrdf = (filename: string): boolean => {
  const lower = filename.toLowerCase();
  return urdfFileTypes.some((ext) => lower.endsWith(`.${ext}`));
};
